// Copyright (c) Meta Platforms, Inc. and affiliates.

/**
 * @file containerReveal.pool.stylex.ts
 * @input Uses StyleX, theme tokens
 * @output A fixed pool of scoped markers, each paired with its reveal style
 *   blocks (reveal / conceal, each with a layout-preserved variant) compiled
 *   against that marker.
 * @position Internal to useContainerReveal. GENERATED by
 *   scripts/gen-container-reveal-pool.mjs — do not edit by hand.
 *
 * WHY A POOL: `stylex.when.ancestor(':hover', marker)` welds the marker's
 * class into the compiled selector (`.marker:hover *`), so a marker and the
 * styles referencing it are inseparable at compile time. A single shared
 * marker would leak hover/focus across NESTED reveal containers (an ancestor
 * container's `:hover` matches a descendant container's revealed content).
 * Pre-declaring N markers lets useContainerReveal hand each concurrently
 * mounted container a distinct marker (free-list in useContainerReveal),
 * isolating nested containers without the caller authoring any StyleX.
 *
 * SYNC: When the block shape changes, edit
 * scripts/gen-container-reveal-pool.mjs and useContainerReveal.ts, then
 * regenerate (node scripts/gen-container-reveal-pool.mjs) and commit.
 */

import * as stylex from '@stylexjs/stylex';
import "../theme/tokens.stylex.js";
import { durationVars, easeVars } from "../theme/tokens.stylex.js";
export const POOL_SIZE = 6;
export const m0 = {
  x177fznd: "x177fznd",
  $$css: true
};
const s0 = {
  reveal: {
    k1ekBW: "x1n1p2mu",
    kIyJzY: "x1tw3moq xsr0bmt",
    kAMwcw: "xlr8y92",
    kzIqYQ: "xd00j3c",
    kIr0Dl: "x11ixquu x1ue31p x134zogi x7so5qh x1eb35i0",
    kSiTet: "xg01cxk xz63v9m x1ceiq2s xhva3ql",
    kVAEAm: "x10l6tqk xd2i8i8 xw895rg x4k19zs",
    $$css: true
  },
  revealLayoutPreserved: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "xg01cxk xz63v9m x1ceiq2s xhva3ql",
    $$css: true
  },
  conceal: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "x1hc1fzr x1d23w33",
    $$css: true
  },
  concealLayoutPreserved: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "x1hc1fzr x1d23w33",
    $$css: true
  }
};
export const m1 = {
  x1e36hu2: "x1e36hu2",
  $$css: true
};
const s1 = {
  reveal: {
    k1ekBW: "x1n1p2mu",
    kIyJzY: "x1tw3moq xsr0bmt",
    kAMwcw: "xlr8y92",
    kzIqYQ: "xd00j3c",
    kIr0Dl: "x11ixquu xqw8whb x1xhgmdq x7so5qh x1eb35i0",
    kSiTet: "xg01cxk x7g73g2 x8e9lel xhva3ql",
    kVAEAm: "x10l6tqk x13sqjsa xxj8d0r x4k19zs",
    $$css: true
  },
  revealLayoutPreserved: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "xg01cxk x7g73g2 x8e9lel xhva3ql",
    $$css: true
  },
  conceal: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "x1hc1fzr x19f70rm",
    $$css: true
  },
  concealLayoutPreserved: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "x1hc1fzr x19f70rm",
    $$css: true
  }
};
export const m2 = {
  x10zkftw: "x10zkftw",
  $$css: true
};
const s2 = {
  reveal: {
    k1ekBW: "x1n1p2mu",
    kIyJzY: "x1tw3moq xsr0bmt",
    kAMwcw: "xlr8y92",
    kzIqYQ: "xd00j3c",
    kIr0Dl: "x11ixquu xrhii57 xeozflw x7so5qh x1eb35i0",
    kSiTet: "xg01cxk xe0m1oz xtpmopf xhva3ql",
    kVAEAm: "x10l6tqk x1k2a1sm xs5no71 x4k19zs",
    $$css: true
  },
  revealLayoutPreserved: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "xg01cxk xe0m1oz xtpmopf xhva3ql",
    $$css: true
  },
  conceal: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "x1hc1fzr xramsae",
    $$css: true
  },
  concealLayoutPreserved: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "x1hc1fzr xramsae",
    $$css: true
  }
};
export const m3 = {
  xbjq1vy: "xbjq1vy",
  $$css: true
};
const s3 = {
  reveal: {
    k1ekBW: "x1n1p2mu",
    kIyJzY: "x1tw3moq xsr0bmt",
    kAMwcw: "xlr8y92",
    kzIqYQ: "xd00j3c",
    kIr0Dl: "x11ixquu xtj9ir3 x1okg2q x7so5qh x1eb35i0",
    kSiTet: "xg01cxk xnsjgr4 x1y0vk26 xhva3ql",
    kVAEAm: "x10l6tqk x1cuf62g x1qy2sty x4k19zs",
    $$css: true
  },
  revealLayoutPreserved: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "xg01cxk xnsjgr4 x1y0vk26 xhva3ql",
    $$css: true
  },
  conceal: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "x1hc1fzr x177ftvf",
    $$css: true
  },
  concealLayoutPreserved: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "x1hc1fzr x177ftvf",
    $$css: true
  }
};
export const m4 = {
  x3z7t8n: "x3z7t8n",
  $$css: true
};
const s4 = {
  reveal: {
    k1ekBW: "x1n1p2mu",
    kIyJzY: "x1tw3moq xsr0bmt",
    kAMwcw: "xlr8y92",
    kzIqYQ: "xd00j3c",
    kIr0Dl: "x11ixquu x1ybz0u4 x1fpm3bq x7so5qh x1eb35i0",
    kSiTet: "xg01cxk x1qps2i7 x1a7n03g xhva3ql",
    kVAEAm: "x10l6tqk xeilikp x1xz04m3 x4k19zs",
    $$css: true
  },
  revealLayoutPreserved: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "xg01cxk x1qps2i7 x1a7n03g xhva3ql",
    $$css: true
  },
  conceal: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "x1hc1fzr x1k1siky",
    $$css: true
  },
  concealLayoutPreserved: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "x1hc1fzr x1k1siky",
    $$css: true
  }
};
export const m5 = {
  x6dglqq: "x6dglqq",
  $$css: true
};
const s5 = {
  reveal: {
    k1ekBW: "x1n1p2mu",
    kIyJzY: "x1tw3moq xsr0bmt",
    kAMwcw: "xlr8y92",
    kzIqYQ: "xd00j3c",
    kIr0Dl: "x11ixquu x17lvmk x192eg1j x7so5qh x1eb35i0",
    kSiTet: "xg01cxk x52nu6g xt179ik xhva3ql",
    kVAEAm: "x10l6tqk x8j1s1q x8gw32m x4k19zs",
    $$css: true
  },
  revealLayoutPreserved: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "xg01cxk x52nu6g xt179ik xhva3ql",
    $$css: true
  },
  conceal: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "x1hc1fzr xenj0cg",
    $$css: true
  },
  concealLayoutPreserved: {
    k1ekBW: "x19991ni",
    kIyJzY: "xuedmi6 x12w9bfk",
    kAMwcw: "xlr8y92",
    kSiTet: "x1hc1fzr xenj0cg",
    $$css: true
  }
};

// The compiled StyleX style objects carry `when.ancestor` conditionals that
// the public `StyleXStyles` type does not model, so the slot shape is inferred
// from the generated blocks rather than annotated.
export const POOL = [{
  marker: m0,
  reveal: s0.reveal,
  revealLayoutPreserved: s0.revealLayoutPreserved,
  conceal: s0.conceal,
  concealLayoutPreserved: s0.concealLayoutPreserved
}, {
  marker: m1,
  reveal: s1.reveal,
  revealLayoutPreserved: s1.revealLayoutPreserved,
  conceal: s1.conceal,
  concealLayoutPreserved: s1.concealLayoutPreserved
}, {
  marker: m2,
  reveal: s2.reveal,
  revealLayoutPreserved: s2.revealLayoutPreserved,
  conceal: s2.conceal,
  concealLayoutPreserved: s2.concealLayoutPreserved
}, {
  marker: m3,
  reveal: s3.reveal,
  revealLayoutPreserved: s3.revealLayoutPreserved,
  conceal: s3.conceal,
  concealLayoutPreserved: s3.concealLayoutPreserved
}, {
  marker: m4,
  reveal: s4.reveal,
  revealLayoutPreserved: s4.revealLayoutPreserved,
  conceal: s4.conceal,
  concealLayoutPreserved: s4.concealLayoutPreserved
}, {
  marker: m5,
  reveal: s5.reveal,
  revealLayoutPreserved: s5.revealLayoutPreserved,
  conceal: s5.conceal,
  concealLayoutPreserved: s5.concealLayoutPreserved
}];